module.exports = __webpack_public_path__ + "img/immagine_guatemala.eaa18df1.jpg";